/* Atlas Wood Company: homepage sections. Reveal-on-scroll for every .awc-h section, and the wood switcher on the canvas feature. */
(function () {
  function init(root) {
    if (root.dataset.awcInit) return; root.dataset.awcInit = '1';
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && Shopify.designMode);
    if (!still && 'IntersectionObserver' in window) {
      root.classList.add('is-js');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .1 });
      root.querySelectorAll('[data-rv]').forEach(function (el) { io.observe(el); });
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-ready'); }); });
    } else { root.classList.add('is-ready'); }

    // canvas feature: the swatches swap the photo, price, button and link together
    var ws = root.querySelectorAll('[data-hc-w]');
    if (ws.length) {
      var imgs = root.querySelectorAll('[data-hc-img]'), from = root.querySelector('[data-hc-from]'), btn = root.querySelector('[data-hc-btn]'), lbl = root.querySelector('[data-hc-lbl]'), tag = root.querySelector('[data-hc-tag]');
      ws.forEach(function (w) {
        w.addEventListener('click', function () {
          var i = w.dataset.hcW;
          ws.forEach(function (x) { var on = x === w; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', String(on)); });
          imgs.forEach(function (im) { im.classList.toggle('is-on', im.dataset.hcImg === i); });
          if (from) from.textContent = w.dataset.from;
          if (btn) btn.href = w.dataset.url;
          if (lbl) lbl.textContent = w.dataset.name;
          if (tag) tag.textContent = w.dataset.name;
        });
      });
    }
  }
  function all() { document.querySelectorAll('.awc-hm').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();

/* Reviews: count up, rotate the featured quote, pause on hover or focus */
(function () {
  function go(root) {
    if (root.dataset.hrInit) return; root.dataset.hrInit = '1';
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var qs = root.querySelectorAll('[data-hr-q]'), bars = root.querySelectorAll('.awc-hr__bar'), stage = root.querySelector('[data-hr-stage]');
    var i = 0, DUR = 7000, t = null, left = DUR, started = 0, paused = false;
    function show(n) {
      i = (n + qs.length) % qs.length;
      qs.forEach(function (q, k) { q.classList.toggle('is-on', k === i); q.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      bars.forEach(function (b, k) { b.classList.remove('is-on'); b.classList.toggle('is-done', k < i); void b.offsetWidth; if (k === i) b.classList.add('is-on'); });
      clearTimeout(t); left = DUR; if (!still && !paused) { started = Date.now(); t = setTimeout(function () { show(i + 1); }, DUR); }
    }
    function pause() { if (paused || still) return; paused = true; stage.classList.add('is-paused'); clearTimeout(t); left -= Date.now() - started; }
    function resume() { if (!paused) return; paused = false; stage.classList.remove('is-paused'); started = Date.now(); t = setTimeout(function () { show(i + 1); }, Math.max(300, left)); }
    if (qs.length > 1) {
      root.style.setProperty('--dur', DUR / 1000 + 's');
      root.querySelector('[data-hr-next]').addEventListener('click', function () { show(i + 1); });
      root.querySelector('[data-hr-prev]').addEventListener('click', function () { show(i - 1); });
      stage.addEventListener('mouseenter', pause); stage.addEventListener('mouseleave', resume);
      stage.addEventListener('focusin', pause); stage.addEventListener('focusout', resume);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { show(0); io.disconnect(); } }, { threshold: .3 });
        io.observe(stage);
      } else show(0);
    } else if (stage) { var nav = stage.querySelector('.awc-hr__nav'); if (nav) nav.hidden = true; }
    // count the rating and review total up when they come into view
    var num = root.querySelector('[data-count]'), cnt = root.querySelector('[data-count-to]');
    if (!still && num && 'IntersectionObserver' in window) {
      var target = parseFloat(num.dataset.count), total = parseInt(cnt.dataset.countTo, 10);
      num.textContent = '0.00'; cnt.textContent = '0';
      var io2 = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io2.disconnect();
        var t0 = performance.now();
        (function f(now) { var p = Math.min(1, (now - t0) / 1600), e = 1 - Math.pow(1 - p, 4);
          num.textContent = (target * e).toFixed(2); cnt.textContent = Math.round(total * e).toLocaleString();
          if (p < 1) requestAnimationFrame(f); })(t0);
      }, { threshold: .5 });
      io2.observe(num);
    }
  }
  /* Frame light: the room darkens and the light comes on as the section scrolls up the screen; the switch flips it by hand */
  function light(root) {
    if (root.dataset.hlInit) return; root.dataset.hlInit = '1';
    var sw = root.querySelector('[data-hl-switch]'), lbl = root.querySelector('[data-hl-label]'), manual = null, cur = -1;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function set(k) {
      k = Math.max(0, Math.min(1, k)); if (Math.abs(k - cur) < .002) return; cur = k;
      root.style.setProperty('--k', k.toFixed(3));
      var on = k > .5; root.classList.toggle('is-on', on);
      if (sw) { sw.setAttribute('aria-pressed', String(on)); lbl.textContent = on ? 'Turn it off' : 'Turn it on'; }
    }
    function fromScroll() {
      if (manual !== null) return;
      var r = root.getBoundingClientRect(), vh = innerHeight;
      // dark once the section's middle reaches 45% of the screen; starts as it enters from below
      var mid = r.top + r.height / 2, p = (vh * 1.05 - mid) / (vh * .6);
      set(still ? (p > .5 ? 1 : 0) : p);
    }
    function animTo(to) {
      if (still) { set(to); return; }
      var from = cur, t0 = performance.now();
      (function f(now) { var p = Math.min(1, (now - t0) / 900), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; set(from + (to - from) * e); if (p < 1) requestAnimationFrame(f); })(t0);
    }
    if (sw) sw.addEventListener('click', function () { manual = cur > .5 ? 0 : 1; animTo(manual); });
    var tick = false;
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(function () { tick = false; fromScroll(); }); } }, { passive: true });
    addEventListener('resize', fromScroll);
    set(0); fromScroll();
  }
  function all() { document.querySelectorAll('.awc-hr').forEach(go); document.querySelectorAll('[data-hl]').forEach(light); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();
